// extracted by mini-css-extract-plugin
export default {"content-wrapper":"Layout_content-wrapper__eogfb"};